import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-video-icon/jb-video-icon.css.ts
var jb_video_icon_css_default = i`*,*::before,*::after{box-sizing:border-box}*:focus-visible{outline-color:rgb(var(--theme-color-signal-blue, 0 37 255));outline-offset:6px;outline-style:var(--focus-outline-style, auto)}div,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,ol,ul,li,form,legend,label,table,header,footer,nav,section,figure{margin:0;padding:0}a{color:inherit}:host{color:var(--host-color, #141e55)}svg{fill:var(--stroke-color, rgba(20, 30, 85, var(--theme-opacity-20, 0.2)));stroke:var(--stroke-color, rgba(20, 30, 85, var(--theme-opacity-20, 0.2)))}svg circle{fill:rgba(0,0,0,0)}`;

export {
  jb_video_icon_css_default
};
